import React from 'react';
import ChatWindow from './ChatWindow';

const RadAi = () => {
  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: '100%' }}
    >
      <ChatWindow />
    </div>
  );
};

export default RadAi;
